import { type MouseEvent } from 'react'
import { type AttachmentId } from '@terros/common'
import { Group, Text, type TextProps, Tooltip } from '@mantine/core'
import { Size } from '@front/model'
import { MaterialSymbolIcon } from '../terros'
import { AttachmentLoader } from './AttachmentLoader'

type ViewAttachmentProps = {
  attachmentId: AttachmentId
  textProps?: TextProps
}
export const ViewAttachment = ({ attachmentId, textProps }: ViewAttachmentProps) => {
  return (
    <AttachmentLoader attachmentId={attachmentId}>
      {({ data }) => (
        <Group wrap='nowrap' gap={Size.space.md}>
          <MaterialSymbolIcon icon='attach_file' />
          <Tooltip label='View attachment'>
            <Text
              c='dimmed'
              lineClamp={1}
              component='a'
              className='text-left hover:underline'
              href={data.downloadUrl}
              target='_blank'
              onClick={(e: MouseEvent) => e.stopPropagation()}
              {...textProps}
            >
              {data.filename}
            </Text>
          </Tooltip>
        </Group>
      )}
    </AttachmentLoader>
  )
}
